import * as moment from "moment";

export class DateUtil {

  static getIsoFormatDate(date: any): string {
    if (date)
      return new Date(date).toISOString()
    return date
  }

  /*
  given from_date and to_date, return a date range where from_date will be first day of next month from last year and
  to date will be last day of next month from last year
   */

  static getPreviousYearDateRange(from_date: Date, to_date: Date): { from_date: Date, to_date: Date } {
    let from = new Date(from_date)
    let to = new Date(to_date)
    from = moment(from).subtract(1, 'year').add(1, 'month').toDate()
    to = moment(to).subtract(1, 'year').add(1, "month").toDate()

    from.setDate(1) // set first day of month
    to.setDate(new Date(to.getFullYear(), to.getMonth() + 1, 0).getDate()) // set last day of month

    return {from_date: from, to_date: to}
  }

}
